<template>
  <div>
    <section class="info-section pb-3">
      <i class="fas fa-info-circle" />
      <span class="info-section-title">{{ title }}</span>
    </section>
    <section :class="{ 'info-section-margin-left': !noBodyMargin }">
      <slot />
    </section>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '' },
    noBodyMargin: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.info-section {
  text-align: left;
  font: Bold 16px/19px Lato;
  letter-spacing: 0px;
  color: #3f5b60;
  padding-left: 10px;
}
.info-section-title {
  margin-left: 7px;
}
.info-section i {
  color: #ff7058;
}
.info-section-margin-left {
  margin-left: 32px;
}
</style>
